import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>About Us</h3>
          <p>Lastbites is dedicated to fighting hunger in our community.</p>
        </div>
        <div className="footer-section">
          <h3>Get Involved</h3>
          <ul>
            <li><a href="/volunteer">Volunteer</a></li>
            <li><a href="/donate">Donate Food</a></li>
            <li><a href="/donate-money">Donate Money</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><a href="/help-locator">Help Locator</a></li>
            <li><a href="/food-safety">Food Safety Guidelines</a></li>
            <li><a href="/nutrition-info">Nutrition Information</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: <a href="mailto:info@yourorganization.com">info@lastbites.com</a></p>
          <p>Phone: <a href="tel:+1234567890">+91 1234567890</a></p>
          <p>Follow us:</p>
          {/* <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
          </div> */}
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Lastbites. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
